import React from 'react'

const Footer = () => {
  return (
    <>
      <div className='mainFooter'>
        <h3>Made by developer shaon</h3>
      </div>
    </>
  )
}

export default Footer
